// extracted by mini-css-extract-plugin
export var standaloneTable = "_gc-0";
export var standaloneTableWithBodyFill = "_gc-1";
export var withExtraHeader = "_gc-2";